const API_BASE = "https://cloudgenomics.net/api";
export default API_BASE;
